import ApiGateway from "../../explorer/services/ApiGateway";
import { SparePartsService } from "../../explorer/services/SparePartsService";
import { BusinessUnit } from "../../explorer/types/SpareParts/BusinessUnit";
import {
  Site,
  TListPart,
  Machine,
} from "../../explorer/types/SpareParts";
import { endpoints } from "../configuration/endpoints";
import { Basket } from "../../explorer/types/";
import { BomItemDetails } from "../../explorer/types/SpareParts/BomItemDetails";
import { MachineDocument } from "../../explorer/types/SpareParts/MachineDocument";
import { Assembly } from "../../explorer/types/SpareParts/Assembly";
import { defaultLayoutSearch } from "../configuration/defaultSettings";
import { getLayoutSearch, setLayoutSearch } from "../../explorer/utils/NavigationUtils";

export class CustomSparePartsService extends SparePartsService {
  public getSites = (brand: string): Promise<Site[]> => {
    return new Promise<Site[]>((resolve, reject) => {
      ApiGateway()
        .get<Site[]>(endpoints.spareParts.sites.replace("{brand}", brand))
        .then((result) => resolve(result.data))
        .catch((error) => reject(error));
    });
  };

  public getCurrentSite = (brand: string): Promise<Site> => {
    return new Promise<Site>((resolve, reject) => {
      ApiGateway()
        .get<Site>(endpoints.spareParts.currentSite.replace("{brand}", brand))
        .then((result) => resolve(result.data))
        .catch((error) => reject(error));
    });
  };

  public setCurrentSite = (brand: string, currentSite: Site) => {
    return new Promise<Site>((resolve, reject) => {
      ApiGateway()
        .put<Site>(
          endpoints.spareParts.currentSite.replace("{brand}", brand),
          currentSite
        )
        .then((result) => resolve(result.data))
        .catch((error) => reject(error));
    });
  };

  public getBusinessUnits = (
    brand: string,
    customerSiteCode: string
  ): Promise<BusinessUnit[]> => {
    return new Promise<BusinessUnit[]>((resolve, reject) => {
      ApiGateway()
        .get<BusinessUnit[]>(
          endpoints.spareParts.businessUnits
            .replace("{brand}", brand)
            .replace("{customerSiteCode}", customerSiteCode)
        )
        .then((result) => resolve(result.data))
        .catch((error) => reject(error));
    });
  };

  public getParts = (
    brand: string,
    params: any,
    extras?: any
  ): Promise<TListPart[]> => {
    return new Promise<TListPart[]>((resolve, reject) => {
      ApiGateway()
        .get<TListPart[]>(
          `${endpoints.spareParts.searchparts.replace("{brand}", brand)}`,
          {
            params: params,
            ...extras,
          }
        )
        .then((result) => resolve(result.data))
        .catch((error) => reject(error));
    });
  };

  public getMachinesSearched = (
    brand: string,
    value: string
  ): Promise<Machine[]> => {
    return new Promise<Machine[]>((resolve, reject) => {
      ApiGateway()
        .get<Machine[]>(
          endpoints.spareParts.searchMachines
            .replace("{brand}", brand)
            .replace("{value}", encodeURIComponent(value))
        )
        .then((result) => resolve(result.data))
        .catch((error) => reject(error));
    });
  };

  public setLayoutSearch = (layoutType: string): Promise<void> => {
    return new Promise((resolve, reject) => {
      // ApiGateway()
      //   .put<Basket>(endpoints.spareParts.setLayoutSearch, {
      //     layoutType: layoutType,
      //   })
      //   .then((result) => resolve(result.data))
      //   .catch((error) => reject(error));
      setLayoutSearch(layoutType);
      resolve();
    });
  };

  public getLayoutSearch = (): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
      //  ApiGateway()
      //    .get<string>(endpoints.spareParts.getLayoutSearch)
      //    .then((result) => resolve(result.data))
      //    .catch((error) => reject(error));

      resolve(getLayoutSearch());
    });
  };

  public getMachineById = (
    brand: string,
    machineId: string
  ): Promise<Machine> => {
    return new Promise<Machine>((resolve, reject) => {
      ApiGateway()
        .get<Machine>(
          endpoints.spareParts.getMachineById
            .replace("{brand}", brand)
            .replace("{machineId}", machineId)
        )
        .then((result) => resolve(result.data))
        .catch((error) => reject(error));
    });
  };

  public getTechnicalDocByMachineId = (
    machineId: string,
    lang?: string
  ): Promise<MachineDocument[]> => {
    return new Promise<MachineDocument[]>((resolve, reject) => {
      ApiGateway()
        .get<MachineDocument[]>(
          endpoints.spareParts.getTechnicalDocByMachineId.replace(
            "{machineId}",
            machineId
          ) + (lang
            ? "?lang=" + lang
            : "")
        )
        .then((result) => resolve(result.data))
        .catch((error) => reject(error));
    });
  };

  public getMaintListByMachineId = (
    machineId: string,
    lang: string
  ): Promise<BomItemDetails[]> => {
    return new Promise<BomItemDetails[]>((resolve, reject) => {
      ApiGateway()
        .get<BomItemDetails[]>(
          endpoints.spareParts.getMaintListByMachineId.replace(
            "{machineId}",
            machineId
          ) +
            "?lang=" +
            lang
        )
        .then((result) => resolve(result.data))
        .catch((error) => reject(error));
    });
  };

  public getEmergListByMachineId = (
    machineId: string,
    lang: string
  ): Promise<BomItemDetails[]> => {
    return new Promise<BomItemDetails[]>((resolve, reject) => {
      ApiGateway()
        .get<BomItemDetails[]>(
          endpoints.spareParts.getEmergListByMachineId.replace(
            "{machineId}",
            machineId
          ) +
            "?lang=" +
            lang
        )
        .then((result) => resolve(result.data))
        .catch((error) => reject(error));
    });
  };

  public getAssembly = (
    brand: string,
    machineId: string,
    naturalKey: string,
    lang: string
  ): Promise<Assembly> => {
    return new Promise<Assembly>((resolve, reject) => {
      ApiGateway()
        .get<Assembly>(
          endpoints.spareParts.getAssemblyItems
            .replace("{brand}", brand)
            .replace("{machineId}", machineId)
            .replace("{naturalKey}", naturalKey) +
            "?lang=" +
            lang
        )
        .then((result) => resolve(result.data))
        .catch((error) => reject(error));
    });
  };

  public getMachineBOMById = (
    brand: string,
    machineId: string,
    lang: string
  ): Promise<BomItemDetails[]> => {
    return new Promise<BomItemDetails[]>((resolve, reject) => {
      ApiGateway()
        .get<BomItemDetails[]>(
          endpoints.spareParts.getMachineBOMById
            .replace("{brand}", brand)
            .replace("{machineId}", machineId) +
            "?lang=" +
            lang
        )
        .then((result) => resolve(result.data))
        .catch((error) => reject(error));
    });
  };

  public getMachines = (
    brand: string,
    customerSiteCode: string
  ): Promise<Machine[]> => {
    return new Promise<Machine[]>((resolve, reject) => {
      ApiGateway()
        .get<Machine[]>(
          endpoints.spareParts.getMachines
            .replace("{brand}", brand)
            .replace("{customerSiteCode}", customerSiteCode)
        )
        .then((result) => resolve(result.data))
        .catch((error) => reject(error));
    });
  };
}
